import React, { useEffect, useMemo, useState } from "react";
import { Form, Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable } from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import { useParams } from "react-router";
import { editorProjectServices } from "../../../APIServices/Editor/editorProjectServices";

const DeletedProjectManagement = ({
  tableRef,
  onMouseDown,
  projectDeletedList,
  softDeleteRestoreProjectData,
  Show,
  Hide,
  Title,
  fileType,
}) => {
  const { studyId } = useParams();
  const [projectList, setProjectList] = useState([]);

  const getAllEditorProjectData = async () => {
    const data = await editorProjectServices.getEditorProjectData("other", studyId);
    setProjectList(data?.data || []);
  };

  const treeData = useMemo(() => {
    const map = {};
    const roots = [];
    projectList.forEach((item) => {
      map[item.uniqueId || item.projectId] = {
        ...item,
        children: [],
        lockStatus: item.lock === "yes" ? "locked" : "unlocked"
      };
    });
    projectList.forEach((item) => {
      if (item.parentId && map[item.parentId]) {
        map[item.parentId].children.push(map[item.uniqueId || item.projectId]);
      } else {
        roots.push(map[item.uniqueId || item.projectId]);
      }
    });
    const setPathAndLock = (nodes, parentPath = "", parentLocked = false) => {
      nodes.forEach(node => {
        const currentPath = parentPath ? `${parentPath}/${node.name}` : node.name;
        node.path = currentPath;
        const currentLocked = parentLocked || node.lock === "yes";
        node.lockStatus = currentLocked ? "locked" : "unlocked";
        if (node.children.length > 0) {
          setPathAndLock(node.children, currentPath, currentLocked);
        }
      });
    };
    setPathAndLock(roots);
    return roots;
  }, [projectList]);

  const findByUniqueId = (node, uniqueId) => {
    if (!node) return null;
    if (Array.isArray(node)) {
      for (let n of node) {
        const found = findByUniqueId(n, uniqueId);
        if (found) return found;
      }
      return null;
    }
    if (node.uniqueId === uniqueId) return node;
    if (node.children && node.children.length > 0) {
      for (let child of node.children) {
        const found = findByUniqueId(child, uniqueId);
        if (found) return found;
      }
    }
    return null;
  };

  useEffect(() => {
    getAllEditorProjectData();
  }, []);

  return (
    <Offcanvas
      show={Show}
      onHide={Hide}
      style={{ width: 600 }}
      placement="end"
    >
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{Title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="p-0">
        {projectDeletedList?.length === 0 ? (
          <div
            className="hstack justify-content-center"
            style={{ height: "calc(100vh - 44px)" }}
          >
            <NoDataFoundTable MSG={"No Deleted File."} />
          </div>
        ) : (
          <Table ref={tableRef} className="m-0 custom-table" hover striped>
            <thead className="position-sticky top-0">
              <tr>
                <th
                  onMouseDown={(e) => onMouseDown(e, 0)}
                  style={{ width: 45 }}
                  className="text-center"
                >
                  Sr.
                </th>
                <th onMouseDown={(e) => onMouseDown(e, 1)}>Name</th>
                <th
                  onMouseDown={(e) => onMouseDown(e, 2)}
                  style={{ width: 55 }}
                  className="text-center"
                >
                  Restore
                </th>
              </tr>
            </thead>
            <tbody>
              {projectDeletedList?.map((file, index) => {
                const node = findByUniqueId(treeData, file?.uniqueId);
                return (
                  <tr key={index} title="View Details">
                    <td className="text-center">{index + 1}.</td>
                    <td>{file?.name} {file?.extension || ""}</td>
                    <td className="text-center" title="Restore">
                      <MdRestore
                        style={{ fontSize: 16 }}
                        className="text-success CP"
                        onClick={() => {
                          if (treeData?.length > 0) {
                            softDeleteRestoreProjectData(
                              file?._id,
                              "restore",
                              fileType,
                              node?.parentId,
                              node
                            );
                          }
                        }}
                      />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        )}
      </Offcanvas.Body>
    </Offcanvas>
  );
};
export default DeletedProjectManagement;